import {commonActions} from '../../actions/commonActions';
import {userSetList,userSetListForExcel} from '../../actions/userActions';
import {connect} from 'react-redux';
import List from '../../components/user/List';
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../constants";
import {list as stateList} from '../../containers/area/StateListPage';
import {list as areaList} from '../../containers/area/AreaListPage';
import {list as cityList} from '../../containers/area/CityListPage';

const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getListForExcel: (value) => {
        dispatch(listForExcel(value));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    getStateList : (value) => {
        return(dispatch(stateList(value)));
    },
    getCityList : (value) => {
        return(dispatch(cityList(value)));
    },
});

export const listForExcel = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('user/v2/list',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(userSetListForExcel(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

export const list = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('user/v2/list',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(userSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.user.list,
        listForExcel : state.user.listForExcel,
        common       : state.common,
        initialValues: state.user.targetItem,
        areaList     : state.area.areaList,
        stateList     : state.area.stateList,
        cityList     : state.area.cityList,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(List);